<template>
  <div class="card portfolio-detail-card">
    <template v-if="portfolio.id">
      <div class="card-content">
        <div class="columns">
          <div class="column is-1 has-text-centered">
            <!-- icon for type -->
            <span class="icon is-large has-text-primary is-light">
              <PortfolioIcon v-bind:portfolioType="portfolio.portfolio_type"/>
            </span>
            <div class="delete-prospect" v-if="portfolio.portfolio_type === 'prospect'">
              <a @click="confirmDeleteProspect">
                <p>Delete
                  <template>
                    <span>
                      <b-icon
                        pack="fas"
                        icon="trash-alt"
                      />
                    </span>
                  </template>
                </p>
              </a>
            </div>
          </div>
          <div class="column is-5">
            <p class="title is-5" v-if="portfolio.name">
              {{ portfolio.name }}
            </p>
            <p class="has-text-grey-light is-size-7" v-if="portfolio.portfolio_type === 'shareowner'">
                {{ sourceName }}

                 &#9670; 

                {{ new Date(portfolio.updated_at).toLocaleDateString() }}
              
                 &#9670; 
                <a v-if="portfolio.email" class="has-text-grey-light is-size-7" v-bind:href="'mailto:' + portfolio.email">{{ portfolio.email }}</a>
            </p>
            <p class="has-text-grey-light is-size-7" v-else>
                {{ sourceName }}

                 &#9670; 

                Holdings as of: {{ portfolio.holdings_as_of_date ? 
                    `${portfolio.holdings_as_of_date.split('-')[1]}/${portfolio.holdings_as_of_date.split('-')[2]}/${portfolio.holdings_as_of_date.split('-')[0]}` 
                    : new Date(portfolio.created_date).toLocaleDateString()
                }}
              
                 &#9670; 
                <a v-if="portfolio.email" class="has-text-grey-light is-size-7" v-bind:href="'mailto:' + portfolio.email">{{ portfolio.email }}</a>
            </p>

            <a
              class="is-size-7"
              v-bind:href="shareownerEditUrl"
              v-if="portfolio.portfolio_type === 'shareowner' && portfolio.editable">
              <span>Edit</span>
              <b-icon
                pack="fas"
                icon="edit"
              />
            </a>
            <a
              class="is-size-7"
              v-bind:href="modelPortfolioEditUrl"
              v-if="portfolio.portfolio_type === 'modelportfolio' && portfolio.editable">
              <span>Edit</span>
              <b-icon
                pack="fas"
                icon="edit"
              />
            </a>
            <a
              class="is-size-7"
              target="_blank" rel="noreferrer noopener"
              v-bind:href="holdingsUrl"
              v-if="portfolio.has_holdings && portfolio.portfolio_type !== 'prospect'"
            >
              <span>View Holdings</span>
              <b-icon
                pack="fas"
                icon="info-circle"
              />
            </a>
            
            </div><!-- column -->
          <div class="column is-2">
  


              <p v-show="shouldShowDndxButton">
                <a
                  v-bind:href="`/advisor-dashboard/direct-indexing/${portfolio.id}`"
                  target="_blank"
                  class="button is-small is-primary is-light dndx-show"
                >
                  Values Aligned Direct Indexing
                </a>
              </p>
              <p v-show="shouldShowMatchmakerButton">
                <a
                  v-bind:href="`/advisor-dashboard/model-matchmaker/${portfolio.id}`"
                  target="_blank"
                  class="button is-small is-primary is-light dndx-show"
                >
                  Model Matchmaker
                </a>
              </p>
              <div v-if="$root.advisor.hasFeature('Model Matchmaker')">
                <br>
                <b-taglist>
                  <b-tag type="is-info is-light" v-for="modelSetName in modelSetsThatHavePortfolio" :key="modelSetName">
                    {{ modelSetName }}
                  </b-tag>
                </b-taglist>
              </div>
              <IRebalSync v-bind:modelPortfolioId="portfolio.id" v-show="$root.advisor.hasFeature('iRebal Integration') && portfolio.portfolio_type === 'modelportfolio'"/>
              <OrionSync v-bind:portfolioId="portfolio.id" v-bind:portfolioName="portfolio.name" v-show="$root.advisor.hasFeature('Orion Prospect Creation')  && portfolio.portfolio_type === 'modelportfolio'" />
            </div>
            <!-- meta data (Created date, source) -->

          
          
          <div class="column is-one-third has-text-centered">
            <!-- portfolio -->
            
            <div class="columns">
              <div class="column has-text-right">
                <Stack gap="2" class="tw-items-end">
                <div v-if="portfolio.portfolio_type !== 'modelportfolio'" class="buttons has-addons is-right">
                  <a class="button is-outlined is-primary" v-bind:href="questionnaireUrl" target="blank" >
                    Take Questionnaire
                  </a>
                  <template v-if="clientHasQuestionnaireResults">
                    <a v-bind:href="questionnaireResultsUrl" class="button is-primary">Results</a>
                  </template>
                  <template v-else>
                    <span class="button is-primary " disabled>Incomplete</span>
                  </template>
                </div>

                <div v-if="portfolio.portfolio_type !== 'modelportfolio' && $root.advisor.hasFeature('Risk Questionnaire')" class="buttons has-addons is-right">
                  <a class="button is-outlined is-primary" v-bind:href="riskQuestionnaireUrl" target="blank" >
                    Risk Tolerance
                  </a>
                  <template v-if="clientHasRiskQuestionnaireResults">
                    <a
                      :href="`/ui/advisor/risk/results/${portfolio.id}`"
                      class="button is-primary"
                    >
                      Results
                    </a>
                  </template>
                  <template v-else>
                    <span class="button is-primary " disabled>Incomplete</span>
                  </template>
                </div>

                <!-- <div v-if="portfolio.portfolio_type !== 'modelportfolio' && $root.advisor.hasFeature('Meetings')" class="buttons has-addons is-right mt-2">
                  <a class="button is-outlined is-primary" :href="`/ui/advisor/meeting-prep/${portfolio.id}`">
                    Prep for Meeting
                  </a>
                </div> -->
                <div v-if="portfolio.portfolio_type !== 'modelportfolio' && ($root.advisor.hasFeature('Meetings') || $root.advisor.hasFeature('Dossier'))" class="buttons has-addons is-right mt-2">
                  <a class="button is-outlined is-primary" :href="`/ui/advisor/entity/${portfolio.entity_external_id}`">
                    Meetings and Info
                  </a>
                </div>
                <a
                  v-if="portfolio.portfolio_type === 'shareowner' && $root.advisor.hasFeature('Portfolio Checkup')"
                  :to="{
                    name: 'auto-portfolio',
                    query: {
                      portfolio: portfolio.entity_external_id,
                    }
                  }"
                  class="button is-primary is-outlined is-medium tw-mr-2" 
                  rel="noreferrer noopener"
                >
                  Portfolio Intelligence Report
                </a>
                <div
                  v-if="portfolio.portfolio_type !== 'modelportfolio' && advisor && portfolio"
                  class="buttons has-addons is-right">
                  <a
                    :href="`/ui/visitor/wizard?advisor=${advisor.link_slug}&prospect=${portfolio.id}`"
                    class="button is-outlined is-primary"
                    target="blank">
                    Values Picker
                  </a>

                  <a
                    v-if="wizardScreenSets?.length"
                    :href="`/ui/advisor/wizard/results?prospect=${portfolio.id}`"
                    class="button is-primary">
                    Results
                  </a>
                  
                  <span
                    v-else  
                    class="button is-primary"
                    disabled>
                    Incomplete
                  </span>
                </div>

                  <template v-if="portfolio.portfolio_type === 'prospect' && portfolio.default_portfolio">
                    <a
                      v-bind:href="prospectReportUrl"
                      class="button is-primary is-outlined "
                    >
                      Generate Report
                    </a>
                  </template>
                  <template v-else>
                    <Button
                      v-if="portfolio.portfolio_type === 'modelportfolio' && $root.advisor.hasFeature('Portfolio Checkup')"
                      variant="primary"
                      :to="{
                        name: 'auto-portfolio',
                        query: {
                          portfolio: portfolio.entity_external_id,
                        }
                      }"
                      outlined
                      rel="noreferrer noopener"
                      icon-before="fas fa-chart-bar"
                    >
                      Portfolio Intelligence Report
                    </Button>
                    <Button
                      :to="reportUrl"
                      variant="primary"
                      outlined
                      icon-before="fas fa-chart-pie"
                    >
                      Values Report
                    </Button>
                  </template>
                </Stack>
                 <!-- buttons -->
              </div>
            </div>
          </div>
        </div>
        </div><!-- card-content-->
        <div class="bottomcard">
          <div class="columns">
            <div class="column is-10"> 
              <div class="columns nomarginbottom">
                <div class="column is-3">
                  <p class="title is-6">
                    Values
                  </p>
                  <a class="is-size-7" href="#_" v-on:click="openValuesPicker" v-if="portfolio.editable">
                      <b-icon
                        pack="fas"
                        icon="edit"
                      />
                    Select
                  </a>
                  <a
                    class="is-size-7"
                    v-if="portfolio.portfolio_type === 'prospect' && $root.advisor.hasFeature('Orion Prospect Creation')"
                    v-bind:href="`/advisordashboard/portfolio-builder/?values_from=${portfolio.id}`"
                    target="_blank"
                  >
                      <b-icon
                        pack="fas"
                        icon="filter"
                      />
                    Fine Tune 
                  </a>
                </div>
                <div class="column is-8">
                  <ValueTags v-bind:screen_sets="portfolio.screen_sets"/>
                </div>
              </div><!-- columns -->
                
              

            </div>
            <div class="column is-2 has-text-right">  
              <Button
                v-if="portfolio.portfolio_type === 'modelportfolio'"
                :to="{
                  name: 'portfolio-alert',
                  query: {
                    portfolio: portfolio.id,
                  },
                }"
                rel="noreferrer noopener"
                size="3"
              >
                Set Alerts
              </Button>
                <!-- 
                alerts should be the same as values but currently there's no way for them to display. 
                when we have that, let's do that instead of a button
                <p class="title is-6">
                  Alerts
                    <a :href="`/advisor-dashboard/metric-alert-create-advanced?portfolio=${portfolio.id}`" class="is-small" target="_blank" rel="noreferrer noopener">
                      <b-icon
                        pack="fas"
                        icon="edit"
                      />
                    </a>
                    : &nbsp; &nbsp;
                </p>-->
            </div>
          </div>
          
        </div>
      </template>
    <template v-else>
      <b-skeleton width="20%" animated></b-skeleton>
      <b-skeleton width="40%" animated></b-skeleton>
      <b-skeleton width="80%" animated></b-skeleton>
    </template>
  </div>
</template>

<script>
import AccountsModal from './portfolios/AccountsModal.vue';
import PortfolioIcon from './portfolios/PortfolioIcon.vue';
import ValueTags from './ValueTags.vue';
import ValuesPicker from './ValuesPicker.vue';
import DefaultPortfolioButton from './portfolios/DefaultPortfolioButton.vue';
import IRebalSync from '@frontend/dash3/js/components/integrations/irebal/IRebalSync.vue';
import OrionSync from '@frontend/dash3/js/components/integrations/orion/OrionSync.vue';
import { Button, Stack } from '@stakeui';

export default {
  data() {
    return {
      originalValues: [],
    };
  },
  props: {
    portfolio: Object,
    advisor: {
      type: Object,
      required: false,
    },
  },
  components: {
    AccountsModal, PortfolioIcon, ValuesPicker, ValueTags, DefaultPortfolioButton, IRebalSync, OrionSync, Button, Stack,
  },
  methods: {
    openValuesPicker: function(currentlyApplied) {
      if (this.originalValues.length === 0) {
        this.originalValues.push(...this.portfolio.screen_sets);
      }
      console.log(this.portfolio.screen_sets)
      this.$buefy.modal.open({
        parent: this,
        component: ValuesPicker,
        hasModalCard: true,
        trapFocus: true,
        props: {
          additionalValues: this.originalValues,
          currentlyApplied: this.portfolio.screen_sets,
          callback: this.valuesChangeCallback,
        },
      });
    },
    openAccountsModal: function() {
      this.$buefy.modal.open({
        parent: this,
        component: AccountsModal,
        hasModalCard: true,
        trapFocus: true,
        props: {
          portfolioId: this.portfolio.id,
        },
      });
    },
    valuesChangeCallback: function(newValues) {
      this.portfolio.screen_sets = newValues;
      const urlSegment = this.portfolio.id.startsWith('prospect_') ? 'prospects' : 'portfolios';
      fetch(`/api/v1/${urlSegment}/${this.portfolio.id}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': this.$root.$data.csrfToken,
        },
        body: JSON.stringify({
          screen_sets: newValues,
        }),
      });
    },
    confirmDeleteProspect() {
      this.$buefy.dialog.confirm({
        title: 'Deleting Prospect',
        message: `Are you sure you want to delete <b>${this.portfolio.name}</b>?`,
        confirmText: `Yes, delete prospect!`,
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          const response = this.prospectDeleteCallback();
          response.then(success => {
            if (success) {
              window.location.reload();
            } else {
              this.$buefy.toast.open("You do not have permission to delete this prospect. Please contact your firm's administrator.");
            }
          });
        },
        onCancel: () => this.$buefy.toast.open('Operation cancelled!'),
      });
    },
    prospectDeleteCallback: async function() {
      if (this.portfolio.id.startsWith('prospect_')) {
        const result = await fetch(`/api/v1/prospects/${this.portfolio.id}/`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.$root.$data.csrfToken,
          },
        })
            .then(function(response) {
              if (!response.ok) {
                throw Error(response.statusText);
              }
              return true;
            })
            .catch(error => {
              return false;
            });
        return result;
      }
    },
    prepForMeeting() {
      this.$router.push(`/advisor/meeting-prep/${this.portfolio.id}`);
    },
  },
  computed: {
    clientHasQuestionnaireResults: function() {
      return this.portfolio?.has_questionnaire_response;
    },
    clientHasRiskQuestionnaireResults: function() {
      return this.portfolio?.risk_questionnaire_score;
    },
    modelSetsThatHavePortfolio() {
      return this.portfolio?.model_sets?.map(modelSet => modelSet.name);
    },
    shouldShowDndxButton: function() {
      if (!this.$root.advisor.hasFeature('FAFN Direct Indexing')) {
        return false;
      }
      return this.portfolio.id.indexOf('shareowner_') === 0 || this.portfolio.id.indexOf('prospect_') === 0;
    },
    shouldShowMatchmakerButton: function() {
      if (!this.$root.advisor.hasFeature('Model Matchmaker')) {
        return false;
      }
      return this.portfolio.id.indexOf('shareowner_') === 0 || this.portfolio.id.indexOf('prospect_') === 0;
    },
    modelPortfolioEditUrl: function() {
      return `/advisordashboard/model_portfolio_create/?update=${this.portfolio.slug}`;
    },
    shareownerEditUrl: function() {
      return `/advisordashboard/client-nickname/${this.portfolio.slug}/`;
    },
    questionnaireUrl: function() {
      return `${window.location.protocol}//${window.location.host}/questionnaire/questions/v2_${btoa(this.portfolio.id)}/`;
    },
    riskQuestionnaireUrl: function() {
      return `${window.location.protocol}//${window.location.host}/questionnaire/questions/v2_${btoa(this.portfolio.id)}/?questionnaire_type=risk`;
    },
    questionnaireResultsUrl: function() {
      return `${window.location.protocol}//${window.location.host}/questionnaire/review-results/${this.portfolio.id}/`;
    },
    holdingsUrl: function() {
      return `/reportholdings/${this.portfolio.slug}/`;
    },
    reportUrl: function() {
      return {
        name: 'reports',
        query: {
          reporting: this.portfolio.id,
          dollarsOrPercentages: 'dollars',
        }
      }
    },
    prospectReportUrl: function() {
      const params = {
        reporting: this.portfolio.default_portfolio.id,
        values_from: this.portfolio.id,
      };
      return '/ui/advisor/reports/?' + new URLSearchParams(params);
    },
    sourceName: function() {
      if (this.portfolio.portfolio_type === 'modelportfolio') {
        return this.portfolio.editable ? 'Uploaded': 'Firmwide';
      } else if (this.portfolio.portfolio_type === 'shareowner') {
        return this.portfolio.sources.length > 0 && this.portfolio.sources[0];
      } else if (this.portfolio.portfolio_type === 'prospect' && this.portfolio.default_portfolio) {
        return this.portfolio.default_portfolio.name;
      } else {
        return 'No Portfolio';
      }
    },
    wizardScreenSets() {
      return this.portfolio.screen_sets?.filter(screen => {
        return screen.name?.includes('Custom Values for');
      });
    },
  },
  created: function() {
    this.originalValues.push(...this.portfolio.screen_sets);
  },
};
</script>

<style lang="scss">
.pickerTrigger {
  cursor: pointer;
}
.portfolio-detail-card {
  .title {
    margin-bottom: 0.75em;
  }
  .dndx-show {
    margin-top: 1em;
  }
}
.delete-prospect p {
  font-size: .8em;
}
.card {
  margin-bottom: 1.5rem;
}
.bottomcard {
  margin-top: -1.25rem;
  background-color: #fcfcfc;
  padding-left: 1.5rem;
  padding-right: 1.5rem;

}
.tags:last-child {
  margin-bottom: 0rem;
}
.nomarginbottom {
  margin-bottom: -.5em;
}
</style>

